'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARKETING_URL = exports.MARKETING_URL = 'https://www.milanote.com';
var HELP_URL = exports.HELP_URL = 'http://help.milanote.com/';
var BLOG_URL = exports.BLOG_URL = 'https://medium.com/milanote';

var REFERRAL_REDIRECT_URL = exports.REFERRAL_REDIRECT_URL = MARKETING_URL + '/';

var MARKETING_PLANS_URL = exports.MARKETING_PLANS_URL = MARKETING_URL + '/plans';
var MARKETING_POLL_URL = exports.MARKETING_POLL_URL = MARKETING_URL + '/poll';


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/urlConstants.js
// module id = 326
// module chunks = 0